module.exports = __webpack_public_path__ + "static/wip-f1f8817b2b7fe85d6a052e8dac067f12.jpg";